// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3MTyM","overflowing":"ReadFullNote_overflowing__17K3o"};